<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-08 11:00:32
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-11 19:33:05
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<yxCardList>
		<el-checkbox-group v-model="checkedItem" @change="handleCheckedChange">
			<yxCardItem v-for="(row, index) in list" :key="index" class="mt-16">
				<div slot="header">
					<cardItemHeader :row="row" />
				</div>
				<!-- 达人信息 -->
				<drInfo :row="row" />

				<!-- 商品信息 -->
				<goodsInfo :row="row" />

				<!-- 物流信息 -->
				<logisticsInfo :row="row" v-if="row.tabName === '1'" />

				<!-- 申样备注 -->
				<buyerRemark :row="row" v-if="row.tabName === '1'" />

				<!-- 更换链接 -->
				<replaceLink :row="row" v-if="row.tabName === '2' || row.tabName === '3' || row.tabName === '4'" />

				<!-- 达人商务，跟进人 -->
				<drCell :row="row" />

				<!-- 操作按钮 -->
				<buttonCell :row="row" />

				<div slot="footer" v-if="row.tabName === '3' || row.tabName === '4'">
					<cardItemFooter :row="row" />
				</div>
			</yxCardItem>
		</el-checkbox-group>
	</yxCardList>
</template>
<script>
import yxCardList from '@/components/ui/yxCardList';
import yxCardItem from '@/components/ui/yxCardItem';
import drInfo from './components/drInfo.vue';
import goodsInfo from './components/goodsInfo.vue';
import cardItemHeader from './components/cardItemHeader';
import cardItemFooter from './components/cardItemFooter';
import logisticsInfo from './components/logisticsInfo';
import buyerRemark from './components/buyerRemark';
import replaceLink from './components/replaceLink';
import drCell from './components/drCell';
import buttonCell from './components/buttonCell';
export default {
	components: {
		yxCardList,
		yxCardItem,
		cardItemHeader,
		cardItemFooter,
		drInfo,
		goodsInfo,
		logisticsInfo,
		buyerRemark,
		replaceLink,
		drCell,
		buttonCell,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		selectedList: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		selectedList: {
			handler: function (val) {
				this.checkedItem = val;
			},
			deep: true,
		},
	},
	data() {
		return {
			checkedItem: [],
		};
	},
	methods: {
		// 选中单个
		handleCheckedChange(value) {
			let checkedCount = value.length;
			if (checkedCount === this.list.length) {
				this.$emit('changeData', 'allChecked', true);
			}
			this.$emit('changeData', 'isIndeterminate', Number(checkedCount) > 0 && Number(checkedCount) < this.list.length);
			this.checkedItemFn(value);
		},
		// 传出选中信息用于批量操作
		checkedItemFn(val) {
			this.$emit('checkedItemFn', val);
		},
	},
};
</script>